import { createRedux } from 'src/firebase';
import { FeaturedCategory } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: featuredCategoriesReducer,
  docReducer: featuredCategoryDetailReducer,
} = createRedux<FeaturedCategory>('featuredCategories');

export {
  actions,
  actionTypes,
  featuredCategoriesReducer,
  featuredCategoryDetailReducer,
};



// WEBPACK FOOTER //
// ./src/featuredCategories/redux.ts